<template>
  <section class="workcenter-column">
    <header class="workcenter-column__header">
      <strong>{{ title }}</strong>
      <i class="bx bx-dots-horizontal-rounded"></i>
    </header>
    <div class="workcenter-column__tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="workcenter-column__tab"
        :class="{'workcenter-column__tab--active': activeTab === tab.key}"
        @click="$emit('change-tab', tab.key)"
      >
        <span>{{ tab.label }}</span>
        <span v-if="tab.count" class="workcenter-column__count" :class="tab.countClass">{{ tab.count }}</span>
      </button>
    </div>
    <slot name="filters"></slot>
    <div class="workcenter-column__search">
      <input :value="search" type="text" placeholder="Search here" @input="$emit('search', $event.target.value)">
      <i class="bx bx-search"></i>
    </div>
    <div class="workcenter-column__tray">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WorkcenterColumn',
  props: {
    title: { type: String, required: true },
    tabs: { type: Array, default: () => [] },
    activeTab: { type: String, default: '' },
    search: { type: String, default: '' }
  }
}
</script>
